import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";


@Injectable({
    providedIn: 'root',
})
export class SpinnerService {
    public isLoaging = new BehaviorSubject<boolean>(false);

    // Requisições em andamento: com várias em paralelo, o spinner só some
    // quando a última termina (antes a primeira a terminar o escondia).
    private pendentes = 0;

    public show(): void {
        this.pendentes++;
        this.publicar();
    }

    public hide(): void {
        this.pendentes = Math.max(0, this.pendentes - 1);
        this.publicar();
    }

    private publicar(): void {
        const visivel = this.pendentes > 0;
        if (this.isLoaging.value !== visivel) {
            this.isLoaging.next(visivel);
        }
    }
}